// Navbar: botón de menú, saludo, buscador de módulos, toggle de tema y salir.
import { useNavigate } from '@tanstack/react-router';
import { NAV } from '../lib/nav';
import { useTheme } from '../hooks/useTheme';
import { useAuth } from '../auth/AuthContext';

interface NavbarProps {
  onToggleMenu: () => void;
}

export function Navbar({ onToggleMenu }: NavbarProps) {
  const { isDark, toggle } = useTheme();
  const { user, signOut } = useAuth();
  const navigate = useNavigate();

  const usuario = user?.name || user?.email || 'Usuario';

  const buscar = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key !== 'Enter') return;
    const q = e.currentTarget.value.toLowerCase().trim();
    const hit = NAV.find((n) => n.path.includes(q) || n.title.toLowerCase().includes(q));
    if (hit) {
      navigate({ to: hit.path });
      e.currentTarget.value = '';
    }
  };

  return (
    <header className="navbar">
      <button className="icon-btn" onClick={onToggleMenu} aria-label="Menú">
        <i className="fa-solid fa-bars" />
      </button>
      <div>
        <div className="greet">¡Hola, <span className="accent">{usuario}</span>!</div>
      </div>
      <div className="spacer" />
      <div className="search">
        <i className="fa-solid fa-magnifying-glass" />
        <input placeholder="Buscar módulo..." onKeyDown={buscar} aria-label="Buscar módulo" />
      </div>
      <button className="icon-btn" onClick={toggle} aria-label="Cambiar tema">
        <i className={`fa-solid ${isDark ? 'fa-sun' : 'fa-moon'}`} />
      </button>
      <button className="btn ghost" onClick={() => { void signOut(); }}>
        <i className="fa-solid fa-arrow-right-from-bracket" /> Salir
      </button>
    </header>
  );
}
